import { PropsWithChildren } from 'react';
import { CommonCtxProvider } from './CommonCtxProvider';
import { AuthCtxProvider } from './AuthCtxProvider';
import { APIOptions, PrimeReactProvider } from 'primereact/api';

const primeReactOptions: APIOptions = {
    hideOverlaysOnDocumentScrolling: true,
    zIndex: {
        modal: 1100, // dialog, sidebar
        overlay: 1000, // dropdown, overlaypanel
        menu: 1000, // overlay menus
        tooltip: 1100, // tooltip
        toast: 1200, // toast
    },
    autoZIndex: false,
};

export const ContextAPI = ({ children }: PropsWithChildren) => (
    <AuthCtxProvider>
        <CommonCtxProvider>{children}</CommonCtxProvider>
    </AuthCtxProvider>
);
